import React, { Component } from 'react';
import { connect } from 'react-redux';
import DownloadPdf from 'wt-react/dist/components/DownloadPdf/DownloadPdf';
import i18n from './../../../i18n';
import ReactTooltip from 'react-tooltip';
import './FactSheetDownload.css';


class FactSheetDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPdfModal: false,
    };
  }

  toggleShowPdfModal = () => {
    this.setState({ showPdfModal: !this.state.showPdfModal });
  };

  renderPdf = () => {
    const {
      token,
      clientEmail,
      pdfReportConfigId,
      personalStrategiesIncomePdfId,
      personalStrategiesGrowthPdfId,
      personalStrategyID,
      type,
      personalStrategyModelType,
      tooltip
    } = this.props;
    const { showPdfModal } = this.state;

    let configID;

    if (type === 'commentary') {
      switch (personalStrategyModelType) {
        case 'Strategic':
          configID = personalStrategiesGrowthPdfId;
          break;
        case 'Global Dividend':
          configID = personalStrategiesIncomePdfId;
          break;
        default:
          configID = pdfReportConfigId;
      }
    } else {
      configID = pdfReportConfigId;
    }

    const initialButtonText = type === 'commentary' ? i18n.t('commentary-download-text') : i18n.t('pdf-download-text');
    const modalTitleText = type === 'commentary' ? i18n.t('commentary-download-text') : i18n.t('pdf-download-text');
    const waitingMessageText = i18n.t('pdf-waiting-message-text');

    return (
      <>
        <button className='button' onClick={this.toggleShowPdfModal} data-tip data-for='hover-tip-pdf'>
          {initialButtonText}
        </button>
        <ReactTooltip key='hover-tip-pdf' id='hover-tip-pdf' type='light' className='tooltip' effect='float' multiline={false}>
          {tooltip}
        </ReactTooltip>
        {showPdfModal && (
          <DownloadPdf
            token={token}
            clientEmail={clientEmail}
            configId={configID}
            initialButtonText={initialButtonText}
            modalTitleText={modalTitleText}
            waitingMessageText={waitingMessageText}
            dataspanApiUrl={process.env.REACT_APP_API_URL}
            dpdApiUrl={process.env.REACT_APP_DPD_URL}
            openModalOnLoad={true}
            submitOnLoad={false}
            showCloseText={false}
            callbackOnClose={this.toggleShowPdfModal}
            adhocInputs={[
              { name: 'id', type: 'string', value: personalStrategyID },
              { name: 'token', type: 'string', value: token },
              { name: 'email', type: 'string', value: clientEmail },
            ]}
          />
        )}
      </>
    );
  };

  render() {
    const { openMenu } = this.props;

    if (!openMenu) {
      return null;
    }

    return <>{this.renderPdf()}</>;
  }
}

const mapStateToProps = (state) => ({
  token: state.params.token,
  clientEmail: state.params.clientEmail,
  pdfReportConfigId: state.params.pdfReportConfigId,
  personalStrategiesIncomePdfId: state.params.personalStrategiesIncomePdfId,
  personalStrategiesGrowthPdfId: state.params.personalStrategiesGrowthPdfId,
});

export default connect(mapStateToProps)(FactSheetDownload);
